import Modal from 'components/ui/Modal';
import { useTranslation } from 'translation/useTranslation';

export default function EmployeeDeactivationModal({
  show,
  loading,
  employeeCount = 1,
  finalAssignmentCount = null,
  requiresFinalAssignmentConfirmation = false,
  onCancel,
  onConfirm,
  testId = 'employee-deactivation',
}) {
  const { editableTranslate } = useTranslation();
  const count = requiresFinalAssignmentConfirmation
    ? (finalAssignmentCount ?? employeeCount)
    : employeeCount;
  const title = requiresFinalAssignmentConfirmation
    ? editableTranslate(
      'employee_management.final_assignment_confirmation_title',
      'Letzte aktive Periodenzuordnung entfernen?'
    )
    : editableTranslate(
      'employee_management.deactivate_title',
      'In dieser Periode deaktivieren'
    );
  const body = requiresFinalAssignmentConfirmation ? <>
    <span className="ws-normal d-block">
      {editableTranslate(
        'employee_management.final_assignment_confirmation_body',
        'Mindestens eine ausgewählte Person hat keine weitere aktive Periodenzuordnung. Wenn Sie fortfahren, ist sie keiner aktiven Periode mehr zugeordnet.'
      )}
    </span>
    {count > 0 ? <span className="ws-normal d-block mt-3" data-testid="final-assignment-count">
      {editableTranslate(
        'employee_management.final_assignment_confirmation_count',
        '{count} Beschäftigte sind betroffen.',
        { count }
      )}
    </span> : null}
    <span className="ws-normal d-block mt-3">
      {editableTranslate(
        'employee_management.deactivate_data_preserved',
        'Mitarbeitenden-, Beurteilungs-, Arbeits- und persönliche Daten bleiben gespeichert und werden nicht gelöscht.'
      )}
    </span>
  </> : <span className="ws-normal break-word d-block">
    {editableTranslate(
      employeeCount === 1 ? 'employee_management.deactivate_warning' : 'employee_management.bulk_deactivate_warning',
      employeeCount === 1
        ? 'Die Person wird nur in der aktuellen Periode deaktiviert. Alle Daten bleiben gespeichert und die Person kann später wieder aktiviert werden.'
        : '{count} Beschäftigte werden nur in der aktuellen Periode deaktiviert. Alle Daten bleiben gespeichert und können später durch erneute Aktivierung wieder angezeigt werden.',
      { count: employeeCount }
    )}
  </span>;

  return <Modal
    open={show}
    title={title}
    okLabel={editableTranslate(
      requiresFinalAssignmentConfirmation
        ? 'employee_management.confirm_final_assignment_deactivation'
        : 'employee_management.deactivate',
      requiresFinalAssignmentConfirmation ? 'Trotzdem deaktivieren' : 'Deaktivieren'
    )}
    cancelLabel={editableTranslate('button.cancel', 'Abbrechen')}
    danger={true}
    loading={loading}
    onClose={onCancel}
    onConfirm={onConfirm}
    testIdPrefix={`${testId}-`}
  >
    {body}
  </Modal>;
}
